import classNames from 'classnames'
import { FC } from 'react'

import { TrainingCentreHighlight } from 'partner360/components/trainingCentre/components/trainingCentrePopup/components/trainingCentreContent/components/common/trainingCentreHighlight/TrainingCentreHighlight'

import { ITrainingCentreListItem } from '../../../models'

import styles from './TrainingCentreList.module.scss'

interface ITrainingCentreListProps {
  items: ITrainingCentreListItem[]
  searchValue?: string
}

export const TrainingCentreList: FC<ITrainingCentreListProps> = ({ items, searchValue }) => {
  return (
    <div className={styles.list}>
      {items.map((item) => {
        const Icon = item.icon

        return (
          <button key={item.id} className={styles.listItem} onClick={item.onClick}>
            <span className={styles.listItem__left}>
              {Icon && (
                <span className={styles.listItem__icon}>
                  <Icon />
                </span>
              )}

              <span className={styles.listItem__content}>
                {item.title && (
                  <TrainingCentreHighlight word={searchValue} className={styles.listItem__title}>
                    {item.title}
                  </TrainingCentreHighlight>
                )}

                {item.description && (
                  <TrainingCentreHighlight
                    word={searchValue}
                    className={styles.listItem__description}
                  >
                    {item.description}
                  </TrainingCentreHighlight>
                )}
              </span>
            </span>

            <i className={classNames('kbase kbase-arrow-right', styles.listItem__arrow)} />
          </button>
        )
      })}
    </div>
  )
}
